import Vue from 'vue'
import { firestorePlugin } from 'vuefire'
import VueMaterial from 'vue-material'
import VueParticles from 'vue-particles'
import 'vue-material/dist/vue-material.min.css'
import App from './App.vue'
import router from './router'

Vue.use(firestorePlugin)
Vue.use(VueParticles)
Vue.use(VueMaterial)
Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
